@for (cell of tableTabs; track $index; let columnIndex = $index) {
  @if (loading) { <span [ngClass]="cell.class"><span class="loading-animate height-m color-transparent">{{ cell.title }}</span></span> }
  @else {
    <div class="am-flex-align gap-xxs" [ngClass]="cell.class" (click)="cell.sort_by && sort(cell.sort_by)">
      <span (click)="cell.sortOptions && sort(getActiveSort(cell.sortOptions).sort_by)" class="table-header-cell-title">{{cell.title}}</span>
      @if (cell.tooltipHtml    ) { <span class="am-flex-center text-m tooltip-hover icon-circle-question" [innerHTML]="cell.tooltipHtml"></span> }
      @if (cell.sort_by?.length) { <span class="am-flex-center icon-arrow-down" [ngClass]="{'active': key[0] === cell.sort_by[0], 'rotate-arrow': key[0] === cell.sort_by[0] && reverse[0]}"></span> }
      @if (cell.input) {
        <span [class.checkbox-wrapper]="cell.input.type === 'checkbox'" (click)="headerOptionalCallbackHandler($event, cell, columnIndex)">
          <input [ngClass]="cell.input.class" type="checkbox" [id]="cell.class" [checked]="cell.input.active">
          <label></label>
        </span>
      }
      @if (cell.sortOptions) {
        <div class="am-flex-align gap-xxs z-1">
          <span [ngClass]="getActiveSort(cell.sortOptions).class" class="relative sort-selector" (click)="sortSelectorOpen = !sortSelectorOpen">
            <div class="absolute-full-top-center overflow-hidden" [style.height.px]="getSortSelectorHeight(getSortOptions(cell.sortOptions))">
              <div class="am-flex-column gap-xxs mt-s p-xxs bg-white b-grey color-secondary-grey">
                @for (sub of getSortOptions(cell.sortOptions); track $index; let columnIndex = $index) {
                  <span class="hover-active-blue" [class.color-blue]="sub.active" [ngClass]="sub.class" (click)="selectSortOption(cell, sub)"></span>
                }
              </div>
            </div>
          </span>
          <span class="am-flex-center icon-arrow-down" (click)="reverseSortOptionDirection(cell.sortOptions)" [ngClass]="{'active': key[0] === getActiveSort(cell.sortOptions).sort_by[0], 'rotate-arrow': key[0] === getActiveSort(cell.sortOptions).sort_by[0] && reverse[0]}"></span>
        </div>
      }
    </div>
  }
}
